import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { chunk } from 'lodash';
import { FormattedMessage } from 'react-intl';
import FacetItem from './facetItem';
import FacetImageItem from './facetImageItem';
import { COLOR_GROUP_ID, PRODUCT_FEATURES_GROUP_ID, TECHNOLOGY_GROUP_ID } from '../facetsListConstants';
import { getFacetsToRender } from '../facetListUtils';

class FacetValuesSection extends Component {
  constructor() {
    super();

    this.state = { showMoreResults: false, showLessResults: false };

    this.facetRef = React.createRef();
    this.handleViewMore = this.handleViewMore.bind(this);
    this.handleViewLess = this.handleViewLess.bind(this);
  }

  handleViewMore() {
    this.setState({ showMoreResults: true, showLessResults: true }, () => {
      this.props.onShowAllClick();
    });
  }

  handleViewLess() {
    this.setState({ showMoreResults: false, showLessResults: false });
  }

  render() {
    const { showMoreResults, showLessResults } = this.state;
    const { chunkSize, facet, isActive, sectionTitle } = this.props;
    const facetsToRender = getFacetsToRender(sectionTitle, facet);

    const renderFacetList = facetList =>
      facetList.map(facetItem => {
        const props = {
          ...this.props,
          key: facetItem.id,
          facetItem,
        };
        return [COLOR_GROUP_ID, TECHNOLOGY_GROUP_ID, PRODUCT_FEATURES_GROUP_ID].includes(facet.id) ? (
          <FacetImageItem {...props} />
        ) : (
          <FacetItem {...props} />
        );
      });

    return (
      <>
        {sectionTitle && <div className="facet__item facet__item--title">{sectionTitle}</div>}
        <div className="facet__item-subsection">
          <ul className="facet" ref={this.facetRef}>
            {chunk(facetsToRender, chunkSize).map((facetsChunk, index) => (
              <Fragment key={`section-${facet.id}-${facetsChunk[0].id}`}>
                {!showMoreResults && index > 0 ? null : renderFacetList(facetsChunk)}
              </Fragment>
            ))}
          </ul>
          {!showMoreResults && facetsToRender.length > chunkSize && isActive && (
            <button type="button" className="facet__view-more" onClick={this.handleViewMore}>
              <span className="icon-plus" /> <FormattedMessage id="products.productgrid.showAll" />
            </button>
          )}
          {showLessResults && (
            <button type="button" className="facet__view-less" onClick={this.handleViewLess}>
              <span className="icon-minus" /> <FormattedMessage id="products.productgrid.showLess" />
            </button>
          )}
        </div>
      </>
    );
  }
}

FacetValuesSection.defaultProps = {
  sectionTitle: '',
  isMediumDown: false,
};

FacetValuesSection.propTypes = {
  chunkSize: PropTypes.number.isRequired,
  isMediumDown: PropTypes.bool,
  facet: PropTypes.shape({ id: PropTypes.string }).isRequired,
  isActive: PropTypes.bool.isRequired,
  sectionTitle: PropTypes.string,
  onShowAllClick: PropTypes.func.isRequired,
};

export default FacetValuesSection;
